import EnumBasePicker from './EnumBasePicker'
import { VALUES } from '@/enums/BiweekDays'

class BiweeklyDatePicker extends EnumBasePicker {
  getEnumName () { return 'BiweekDay' }
  getEnumValues () { return VALUES }
}

export default BiweeklyDatePicker



// WEBPACK FOOTER //
// ./src/components/Editors/BiweeklyDatePicker.js